<template>
  <div class="spinner">
    <svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M79.1992 156C89.1797 156 99.0624 154.034 108.283 150.215C117.504 146.395 125.882 140.797 132.939 133.74C139.997 126.683 145.595 118.305 149.414 109.084C153.233 99.8632 155.199 89.9805 155.199 80C155.199 70.0196 153.233 60.1368 149.414 50.9161C145.595 41.6953 139.997 33.3171 132.939 26.2599C125.882 19.2026 117.504 13.6045 108.283 9.78516C99.0624 5.9658 89.1797 4 79.1992 4" stroke="url(#paint0_linear_2027_3104)" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
      <defs>
        <linearGradient id="paint0_linear_2027_3104" x1="79.1992" y1="8" x2="79.1992" y2="152" gradientUnits="userSpaceOnUse">
          <stop :stop-color="color"/>
          <stop offset="0.995" :stop-color="color" stop-opacity="0"/>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    color: {
      type: String,
      default: "#309E3A"
    }
  },
};
</script>
  
<style scoped>
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(-360deg);
  }
}
</style>
